import createOrderMixin from '@/mixins/order/createOrder';
import { doSeckill, getSeckillRemindUrl } from '@/services/seckill';
import { commonLog } from '@/services/app';
import { locationHref } from '@/utils';

const seckillDoSeckillMixin = {
  mixins: [createOrderMixin],
  methods: {
    async mixinHandleDoSeckill(targetType, targetId) {
      const data = await doSeckill(targetType, targetId);
      const { action } = data;
      switch (action) {
        case 'createOrder': {
          const createOrderParams = {
            targetType,
            targetId,
            targetCount: 1,
            payActionSource: 'seckill',
          };
          return this.mixinCreateOrder(createOrderParams);
        }
        case 'next': {
          const { next } = data;
          this.$emit('show-next-seckill', next);
          return Promise.resolve();
        }
        default: {
          commonLog('handleDoSeckillError', action);
          return Promise.reject();
        }
      }
    },
    async mixinHandleSeckillLocation(params) {
      const data = await getSeckillRemindUrl(params);
      const { url } = data;
      locationHref(url);
    },
    async mixinHandleClickSeckillBtn(button) {
      const { action, target, disabled } = button;

      if (disabled) return false;
      button.disabled = true;

      switch (action) {
        case 'getUrl': {
          const { getUrlParams } = target;
          try {
            await this.mixinHandleSeckillLocation(getUrlParams);
            button.disabled = false;
            return Promise.resolve();
          } catch (e) {
            button.disabled = false;
            return Promise.reject(e);
          }
        }
        case 'showUrl': {
          const { url } = target;
          locationHref(url);
          button.disabled = false;
          return Promise.resolve();
        }
        case 'joinProduct': {
          const { id, type } = target;
          try {
            await this.mixinHandleDoSeckill(type, id);
            button.disabled = false;
            return Promise.resolve();
          } catch (e) {
            button.disabled = false;
            return Promise.reject(e);
          }
        }
        case 'showMobile': {
          this.$emit('show-book-mobile', target);
          button.disabled = false;
          return Promise.resolve();
        }
        default: {
          button.disabled = false;
          commonLog('handleClickSeckillBtnActionError', action);
          return Promise.reject();
        }
      }
    },
  },
};

export default seckillDoSeckillMixin;
